import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getdataByIdim_transaction_dependent = (id) => {
  return httpClientImmigration.get(
    server.IM_TRANSACTION_DEPENDENT + `/getbyid/${id}`,
  );
};

export const getAllim_transaction_dependent_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_TRANSACTION_DEPENDENT + `/getAllim_transaction_dependent_Company`,
    query,
  );
};

export const addim_transaction_dependent = (data) => {
  return httpClientImmigration.post(
    server.IM_TRANSACTION_DEPENDENT + `/`,
    data,
  );
};

export const updateim_transaction_dependent = (id, data) => {
  return httpClientImmigration.put(
    server.IM_TRANSACTION_DEPENDENT + `/${id}`,
    data,
  );
};

export const deleteim_transaction_dependent = (id) => {
  return httpClientImmigration.delete(
    server.IM_TRANSACTION_DEPENDENT + `/${id}`,
  );
};
